import type maplibregl from "maplibre-gl";
import type { StyleValue } from "../types";

/**
 *
 */
function buildGlobalStateMultiplier({
	value,
	stateKey,
	fallback = 1,
}: {
	value: StyleValue;
	stateKey: string;
	fallback?: number;
}): maplibregl.ExpressionSpecification {
	return ["*", value, ["number", ["global-state", stateKey], fallback]] as unknown as maplibregl.ExpressionSpecification;
}

export { buildGlobalStateMultiplier };
